import React from 'react';
import '../less/addition-card.less';
import zelena_card_img from "../img/zelena_card_img.png";

export default function template() {
    const title = this.props.match.params.type !== 'apple_pay' ? 'GOOGLE_PAY_BOTTOM_TITLE' : 'APPLE_PAY_BOTTOM_TITLE',
      isMobile = this.isViewportMobile();
    return (
      <div className="main-content-wrapper additional-card">
          <div className="block-wrapper">
              <div className="left-side">
                  <div className="main-info-block">
                      <p className="main-info-block-title" dangerouslySetInnerHTML={{ __html: this.l10n(title) }} />
                      <p className="main-info-block-notice" dangerouslySetInnerHTML={{ __html: this.l10n("APPLE_PAY_BOTTOM_NOTICE") }} />
                  </div>
                  <div className="list-offers-block">
                      <ul>
                          <li><div className={`circle${isMobile ? ' mobile' : ''}`}></div>
                              <span dangerouslySetInnerHTML={{ __html: this.l10n( isMobile ? "APPLE_PAY_BOTTOM_1_MOB" : "APPLE_PAY_BOTTOM_1") }}></span>
                          </li>
                          <li><div className="circle"></div>{this.l10n('APPLE_PAY_BOTTOM_2')}</li>
                          <li><div className="circle"></div>{this.l10n('APPLE_PAY_BOTTOM_3')}</li>
                          <li><div className="circle"></div>{this.l10n('APPLE_PAY_BOTTOM_4')}</li>
                      </ul>
                  </div>
                  <div className="btn-block">
                      <button className="btn-success" onClick={e => window.location.href = `https://zelena.a-bank.com.ua`}>
                          {this.l10n('GC_BTN_ORDER')}
                      </button>
                  </div>
              </div>
              <div className="right-side">
                  <div className="right-side-img-wrapper">
                      <img alt="img-card" src={zelena_card_img} className="img-card"></img>
                  </div>
              </div>
          </div>
      </div>
    );
}
